import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showEffects: false,
    background: '',
    showQrCode: true,
    showRemarks:true,
    showStatistics:true,
    cardType: true,

    isReadNoticeForUser:true,
    useAI:false,
    useRedis:false,
    useThirdService:false,



    footerWidth: 0,
    footerHeight: 0,
    headerWidth: 0,
    headerHeight: 0,
    clientHeight: 0,
    offsetHeight: 0,
    clientWidth: 0,
    offsetWidth: 0,
    theme: 'dark',
    appVersion: '',

  },
  getters: {
  },
  mutations: {
    commitValue(state, payload) {
      state[payload.key] = payload.value;
    },
  },
  actions: {
    changeItem({commit}, {data}) {
      commit("commitValue",data)
    },
  },
  modules: {
  }
})
